import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import AirCompressorsDetailsForm from './air-compressors-details-form';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import MaintenanceHistory from './maintenance-history';
import SafetyChecklist from './safety-checklist';
import CellHistory from './cell-history';
import SafetyChecklistHistory from './safety-checklist-history';
import EditAirCompressors from './edit-air-compressors';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];
const editKeys = ['changed', 'isDeleted'];

const AirCompressorsAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('AirCompressorsAddEdit -> modalData:', modalData);
  const airCompressorsData = modalData;
  const [formData, setFormData] = useState(airCompressorsData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData, setSafetyData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  console.log('AirCompressorsAddEdit -> formData?.id:', formData?.id);
  console.log('AirCompressorsAddEdit -> formData?.airCompressorId:', formData?.airCompressorId);

  const dispatch = useDispatch();
  const isEditMode = Boolean(airCompressorsData?.id || airCompressorsData?.assetNumber);

  const onChangesAirCompressorsForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (data, mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }
    if (activeTabIndex === 3 && newTabIndex !== 3) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Air Compressors">
              <EditAirCompressors
                data={formData}
                onChanges={onChangesAirCompressorsForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Air Compressors Maintenance Details">
              <AirCompressorsDetailsForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesAirCompressorsForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <MaintenanceHistory
                data={formData}
                airCompressorsId={formData?.airCompressorId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist
                airCompressorId={formData?.airCompressorId || formData?.id}
                onCloseModal={handleClose}
                safetyActionRecord={safetyData}
              />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesAirCompressorsForm}
                onCloseModal={handleClose}
                airCompressorsId={formData?.airCompressorId || formData?.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditAirCompressors
            data={formData}
            onChanges={onChangesAirCompressorsForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="air-compressors-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Air Compressors Maintenance Summary' : 'Add Air Compressors'}
      body={body}
      handleClose={handleClose}
    />
  );
};

AirCompressorsAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(AirCompressorsAddEdit);
